import { apiAthenas } from '@/services/api/apiAthenas'

type DeleteAllPartsProps = {
  demandId: string
}
export async function deleteAllParts({ demandId }: DeleteAllPartsProps) {
  await apiAthenas.delete(`demands/${demandId}/parts`)
}
